import React from "react";
import { useStore } from "../../store";
import { Drone } from "../../types";

import "./ThreatBar.css";

function fmtDist(m?: number) {
  if (m == null) return "—";
  return m >= 1000 ? (m / 1000).toFixed(2) + " km" : Math.round(m) + " m";
}

export default function ThreatBar() {
  const drones = useStore(s => s.drones);
  const alarmed = useStore(s => s.alarmedDrones);

  const entries = [...alarmed.entries()];
  const defenseIds = entries.filter(([, s]) => s === "DEFENSE").map(([id]) => id);
  const warningIds = entries.filter(([, s]) => s === "WARNING").map(([id]) => id);

  const level: "DEFENSE" | "WARNING" | "CLEAR" =
    defenseIds.length ? "DEFENSE" : warningIds.length ? "WARNING" : "CLEAR";

  const ids = level === "DEFENSE" ? defenseIds : level === "WARNING" ? warningIds : [];
  const targets = ids.map(id => drones.get(id)).filter(Boolean) as Drone[];
  const primary = targets.slice().sort((a, b) => (a.distanceM ?? 1e12) - (b.distanceM ?? 1e12))[0];

  if (level === "CLEAR") {
    return (
      <div className="threatbar tb-clear">
        <span className="tb-dot" />
        <span className="tb-status">SECTOR CLEAR — NO THREATS</span>
        {drones.size > 0 && <span className="tb-sub">{drones.size} object{drones.size > 1 ? "s" : ""} tracked</span>}
      </div>
    );
  }

  const cls = level === "DEFENSE" ? "tb-alert" : "tb-warn";
  const title = level === "DEFENSE"
    ? `DEFENSE BREACH — ${defenseIds.length} TARGET${defenseIds.length > 1 ? "S" : ""}`
    : `WARNING — ${warningIds.length} IN WARNING ZONE`;

  return (
    <div className={"threatbar " + cls}>
      <div className="tb-head">
        <span className="tb-dot" />
        <span className="tb-status">{title}</span>
      </div>
      {primary && (
        <div className="tb-details">
          <span><b>ID</b> {primary.droneId}</span>
          <span><b>Type</b> {primary.model || primary.sensorType || "Unknown"}</span>
          <span><b>Alt</b> {primary.altitudeM != null ? Math.round(primary.altitudeM) + " m" : "—"}</span>
          <span><b>Speed</b> {primary.speedMs != null ? primary.speedMs.toFixed(1) + " m/s" : "—"}</span>
          <span><b>Dist</b> {fmtDist(primary.distanceM)}</span>
        </div>
      )}
    </div>
  );
}
